import { EditEndUserModal } from 'features/users/components/modals/edit-end-user-modal';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from 'routes/constants';

export const EndUserUpdateView = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  if (!id) return null;

  const closeModal = () => {
    navigate(ROUTES.USERS_APP);
  };

  return (
    <EditEndUserModal id={id} onClose={closeModal} onSuccess={closeModal} />
  );
};
